import { render, staticRenderFns } from "./WelcomeMessagePreview.vue?vue&type=template&id=160e6d85&scoped=true&"
import script from "./WelcomeMessagePreview.vue?vue&type=script&lang=js&"
export * from "./WelcomeMessagePreview.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeMessagePreview.vue?vue&type=style&index=0&id=160e6d85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e6d85",
  null
  
)

export default component.exports